class ProductDownloads
{
    constructor()
    {
        this.selector = '.js-product-downloads';
        this.downloadSingleSelector = '.js-product-downloads__single';
        this.downloadAllSelector = '.js-product-downloads__all';

        this.element = document.querySelector(this.selector);
        this.downloadSingleElements = null;
        this.downloadAllElement = null;

        this.api = orion.api.productDownloads;

        this.productNumber = null;
        this.filePathList = [];
        this.resultingFilenamePrefix = 'orion_download_';
        this.defaultFileExtension = 'zip';
        this.downloadUrl = 'https://downloads.orion-wholesale.com/prepared';
    }

    init()
    {
        if (!this.element)
        {
            return;
        }

        this.productNumber = this.element.dataset.productNumber;
        this.customerId = orion.getCustomerId();
    }

    prepareDownloads(referenceString, filePathList, resultingFilename)
    {
        return this.api.prepareDownload({
            referenceString: referenceString,
            filePathList: filePathList,
            resultingFilename: resultingFilename
        });
    }

    handleDownloadSingleClick(event, path)
    {
        event.preventDefault();

        var fileExtension = path.split('.').pop();

        this.prepareDownloads(
            this.customerId,
            [path],
            this.resultingFilenamePrefix + this.productNumber + '.' + fileExtension
        ).done(function(response)
        {
            window.location.href = this.downloadUrl + response;
        }.bind(this));
    }

    handleDownloadAllClick(event)
    {
        event.preventDefault();

        this.prepareDownloads(
            this.customerId,
            this.filePathList,
            this.resultingFilenamePrefix + this.productNumber + '.' + this.defaultFileExtension
        ).done(function(response)
        {
            window.location.href = this.downloadUrl + response;
        }.bind(this));
    }

    appendProductDownloads()
    {
        if (!this.element || typeof this.productNumber == 'undefined' || !this.productNumber || !this.customerId)
        {
            return;
        }

        this.api.read(this.productNumber).done(function(html)
        {
            this.element.innerHTML = html;

            this.downloadSingleElements = this.element.querySelectorAll(this.downloadSingleSelector);
            this.downloadAllElement = this.element.querySelector(this.downloadAllSelector);

            this.downloadSingleElements.forEach(function(element)
            {
                let { path } = element.dataset;

                this.filePathList.push(path);

                element.addEventListener('click', (event) => this.handleDownloadSingleClick(event, path));
            }.bind(this));

            this.downloadAllElement.addEventListener('click', this.handleDownloadAllClick.bind(this));
        }.bind(this));
    }
}

let productDownloads = new ProductDownloads();

productDownloads.init();
productDownloads.appendProductDownloads();
